import React, { ReactNode } from 'react';
import { assetUrl } from '~/helpers';
import cx from 'classnames';
import { Button, ButtonVariant } from '@vimily/bonjoro-ui-components-v2/Button';
import { Modal } from '@vimily/bonjoro-ui-components-v2/Modal';
import { Link } from 'react-router-dom';

export interface PaymentSuccessModalProps {
  open: boolean;
  onContinueClick?: () => void;
  onCloseClick?: () => void;
  note?: ReactNode;
}

const PaymentSuccessModal = ({
  open,
  onContinueClick,
  onCloseClick,
  note,
}: PaymentSuccessModalProps) => (
  <Modal
    open={open}
    onModalClose={onCloseClick}
    closeButtonClassName='!top-6 !right-6 !w-5'
    className='w-auto h-auto !inset-px !p-0'
  >
    <div
      className={cx([
        'flex flex-col items-center p-8 min-h-[436px] justify-center',
        'bg-center bg-contain md:bg-auto bg-no-repeat',
      ])}
    >
      <h1 className='text-xl mt-0 mb-4 md:text-2xl md:mb-8 '>
        Upgrade successful!
      </h1>
      <h2 className='flex-1 text-center m-0 text-base md:text-xl'>
        On behalf of the entire Bonjoro team, we thank you for your support ;)
      </h2>
      {note}
      <img
        className='w-auto h-auto'
        src={assetUrl('assets/images/gifs/upgrade-success.gif')}
      />
      <div className='flex gap-x-4'>
        <Link to='/billing' target='_blank'>
          <Button
            variant={ButtonVariant.Secondary}
            className='v2-text-neutral-900 !py-2'
          >
            See my settings
          </Button>
        </Link>
        <Button
          variant={ButtonVariant.Primary}
          className='v2-text-neutral-900 !py-2'
          onClick={onContinueClick}
        >
          Continue
        </Button>
      </div>
    </div>
  </Modal>
);

export default PaymentSuccessModal;
